export const useCookieConsent = () => {
  const consent = useCookie('cookie_consent')

  const isAccepted = computed(() => consent.value === 'accepted')
  const isDeclined = computed(() => consent.value === 'declined')
  const isUnset = computed(() => !consent.value)

  const accept = () => {
    useCookie('cookie_consent', {
      maxAge: 60 * 60 * 24 * 365, // 1年
    }).value = 'accepted'
  }

  const decline = () => {
    useCookie('cookie_consent', {
      maxAge: 60 * 60 * 24 * 180, // 半年
    }).value = 'declined'
  }

  return { isAccepted, isDeclined, isUnset, accept, decline }
}
